export default function getAuthorizedManagerCourses(user, courses) {
  const features = user?.meta?.features;
  if (!features?.canManageCourses) return null;

  const authorizedManagerCourseIds = features?.authorizedManagerCourseIds;
  const coursesList = Object.values(courses);

  const authorizedCourses = coursesList.filter((course) =>
    authorizedManagerCourseIds.includes(course.id)
  );

  return authorizedCourses;
}
